// extracted by mini-css-extract-plugin
export default {"section":"Benefits_section__0NLkJ","stage":"Benefits_stage__AQGwY","title":"Benefits_title__RrltT","text":"Benefits_text__I16Tu","contactbutton":"Benefits_contactbutton__94kl9"};